"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HilPackageFamily = void 0;
const z = __importStar(require("zod"));
const merge_values_js_1 = require("../utils/merge-values.js");
const hilPackageFamilySchema = z.object({
    id: z.string(),
    isReviewed: z.boolean().default(false),
    name: z.string(),
    manufacturerId: z.string(),
    ownerId: z.string(),
});
const hilPackageFamilyDtoSchema = z.object({
    isReviewed: z.boolean().optional(),
    name: z.string().trim().min(1).optional(),
});
exports.HilPackageFamily = {
    create: (input) => {
        return hilPackageFamilySchema.parse(input);
    },
    merge: (existing, incoming) => ({
        id: existing.id,
        isReviewed: (0, merge_values_js_1.mergeValues)(existing.isReviewed, incoming.isReviewed),
        name: (0, merge_values_js_1.mergeValues)(existing.name, incoming.name),
        manufacturerId: existing.manufacturerId,
        ownerId: existing.ownerId,
    }),
    schema: hilPackageFamilySchema,
    dtoSchema: hilPackageFamilyDtoSchema,
};
//# sourceMappingURL=hil-package-family.js.map